import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

import baseUrl from './baseURL'

const http = {}

var instance = axios.create({
    timeout: 5000,
    baseURL: baseUrl
})

instance.interceptors.request.use(
    function(config) {
        return config
    },
    function(error) {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        let errorMessage = ''
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = '请求出错'
                    break
                case 401:
                    err.message = '401错误'
                    break
                case 403:
                    err.message = '拒绝访问'
                    break
                case 404:
                    err.message = '请求错误，未找到该资料'
                    break
                case 500:
                    err.message = '服务器出错'
                    break
            }
            errorMessage = err.message
        } else {
            err.message = '连接服务器失败'
            errorMessage = '连接服务器失败'
        }
        Message.error({
            message: errorMessage
        })
        return Promise.reject(errorMessage)
    }
)

http.get = function(url, options) {
    return new Promise((resolve, reject) => {
        instance.get(url, options).then(response => {
            if (response.meta.code === 0) {
                resolve(response)
            } else {
                Message.error({
                    message: response.meta.message
                })
                reject(response.meta.message)
            }
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    })
}

http.post = function(url, data, options) {
    return new Promise((resolve, reject) => {
        instance.post(url, data, options).then(response => {
            if (response.meta.code === 0) {
                resolve(response)
            } else {
                Message.error({
                    message: response.meta.message
                })
                // reject(response.meta.message)
            }
        }).catch(e => {
            console.log(e)
            reject(e)
        })
    })
}

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js